import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from '../objectUtils';

@Pipe({
  name: 'dropdowns',
  standalone: false
})
export class DropdownsPipe implements PipeTransform {
  transform(value: any,
    type: string,
    dropdowns: models.WorkflowDropdownsVM,
    show: "desc" | "code-desc" = "desc"
  ): string {

    if (dropdowns == null || dropdowns == undefined) {
      return value;
    }

    if (dropdowns.options == null || dropdowns.options == undefined) {
      return value;
    }
    if (dropdowns.options.length == 0 ) {
      return value;
    }
    const options = dropdowns.options.filter(el => el.dropdown == type);
;

    let dim = options.find(el => el.value === value);
    if (dim == null)
      return value;

    return show == "desc" ? dim.description : dim.value + " - " + dim.description;
  }
}
